import { SaccoShareButton, SaccoShareNetworks } from "./SaccoShare";

export const SaccoShareStrip = () => (
  <section className="bg-[#0B2A28] text-white" data-testid="sacco-share-strip">
    <div className="mx-auto flex max-w-6xl flex-col gap-8 px-5 py-14 md:flex-row md:items-center md:justify-between">
      <div className="flex gap-5">
        <img src="/og-saccos.jpg" alt="SACCO page preview" className="hidden h-24 w-44 shrink-0 rounded-xl object-cover ring-1 ring-white/15 sm:block" />
        <div>
          <p className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-[#E3B84C]">Know a SACCO that should see this?</p>
          <p className="mt-2 text-xl font-extrabold sm:text-2xl">Share this page with your network</p>
          <p className="mt-1.5 max-w-md text-sm text-[#B9D9D6]">Credit managers, board members and SACCO leaders — send them the link and it opens with a full preview card.</p>
        </div>
      </div>
      <div className="flex flex-col items-start gap-3 md:items-end">
        <SaccoShareButton variant="dark" testid="sacco-share-strip-btn" />
        <SaccoShareNetworks dark />
      </div>
    </div>
  </section>
);
